import { AxiosError } from 'axios';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { QrCodeRedirectLocationState } from 'Models/_HumanWritten/LocationState';
import { checkInQrCode } from 'Services/Api/_HumanWritten/CheckInService';
import alertToast from 'Util/ToastifyUtils';
import { LottieSpinner } from '../Lottie/LottieSpinner';

function QrCodeRedirect() {
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();

	React.useEffect(() => {
		if (!id) {
			alertToast('Invalid QR code', 'error');
			navigate('/ferry-schedule', { replace: true });
			return;
		}

		const request = async () => {
			try {
				const response = await checkInQrCode(id);
				const { data } = response;

				const locationState: QrCodeRedirectLocationState = {
					qrCodeId: id,
				};

				navigate(data, {
					state: locationState,
					replace: true,
				});
			} catch (e: unknown) {
				if (e instanceof AxiosError && e.response?.data) {
					alertToast(e.response.data, 'error');
				} else {
					alertToast('Something went wrong while redirecting', 'error');
				}
				navigate('/ferry-schedule', { replace: true });
			}
		};

		request();
	}, [id, navigate]);

	return <LottieSpinner />;
}

export default QrCodeRedirect;
